<!--
  Copyright (c) MobiFactory. All rights reserved.
  This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
  See LICENSE.txt file in the project root for full license information.
-->

<template>
  <el-select v-model="selectedValue" :placeholder="placeholder" :clearable="clearable" @change="selectionChanged">
    <el-option
      v-for="item in displayedReferenceData"
      :key="item.id"
      :value="item.id"
      :label="getReferenceDataLabel(item)"
    ></el-option>
  </el-select>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CrmReferenceDataSelect",
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    referenceData: {
      type: Array,
      default: () => [],
    },
    displayTitle: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "change"],
  computed: {
    selectedValue: {
      /**
       * Gets selected value
       * @returns {string}
       */
      get() {
        return this.modelValue;
      },
      /**
       * Sets the selected value
       * @param {string} value - new id
       */
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },

    /**
     * Gets displayed reference data
     * @returns {Array} reference data
     */
    displayedReferenceData() {
      let selection = this.referenceData?.filter((rd) => !rd.isDeleted);
      if (selection && !selection.find((rd) => rd.id === this.modelValue)) {
        const deletedSelection = this.referenceData.find((rd) => rd.id === this.modelValue);
        if (deletedSelection) {
          selection.push(deletedSelection);
        }
      }

      return selection;
    },
  },
  methods: {
    /**
     * Gets the reference data label
     * @param {object} referenceData - The reference data
     * @returns {string}
     */
    getReferenceDataLabel(referenceData) {
      let label = this.displayTitle ? referenceData.title : referenceData.label;
      if (referenceData.isDeleted) {
        label += ` (${this.$t("ReferenceDataSelect.DeletedLabel")})`;
      }
      return label;
    },

    /**
     * Handles selection changed
     * @param {object} value - the selected value
     */
    selectionChanged(value) {
      this.$emit("change", value);
    },
  },
});
</script>
